var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 44,
    viewBox: "0 0 70 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_6958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.8147 40.6165H5.18506C5.90108 41.7948 6.67478 42.925 7.51636 44H62.48C63.3182 42.9284 64.0953 41.7948 64.8113 40.6165H64.8147Z",
    fill: "#2D333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9977 33.8459H1.99854C2.39557 35.0036 2.85368 36.1337 3.37288 37.2329H66.6301C67.1425 36.1372 67.6006 35.0036 67.9977 33.8459Z",
    fill: "#2D333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6438 27.0719H0.353027C0.515913 28.2193 0.7297 29.3494 1.00118 30.4555H69.0058C69.2671 29.3494 69.4843 28.2193 69.6472 27.0719H69.6438Z",
    fill: "#2D333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9627 20.3047H0.0407213C0.0101803 20.8664 0 21.428 0 21.9965C0 22.565 0.0101803 23.1267 0.0407213 23.6883H69.9627C69.9898 23.1267 70.0034 22.565 70.0034 21.9965C70.0034 21.428 69.9932 20.8664 69.9627 20.3047Z",
    fill: "#2D333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0024 13.5411H0.997758C0.726282 14.6506 0.512495 15.7808 0.349609 16.9247H69.6404C69.4775 15.7808 69.2603 14.6506 68.999 13.5411H69.0024Z",
    fill: "#2D333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6301 6.76367H3.37288C2.85368 7.85936 2.39557 8.99296 1.99854 10.1507H67.9977C67.6006 8.99296 67.1425 7.85936 66.6301 6.76367Z",
    fill: "#2D333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4834 0H7.51977C6.6782 1.07157 5.90449 2.20172 5.18848 3.38356H64.8181C64.1021 2.20172 63.3216 1.07502 62.4868 0H62.4834Z",
    fill: "#2D333C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_6958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 44,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon2);
export default __webpack_public_path__ + "static/media/home_icon2.b6dc65df20cf6d7e26d0dac90290916f.svg";
export { ForwardRef as ReactComponent };